import { createFileRoute } from "@tanstack/react-router";
import AvMedMarketplaceInsurance, {
  config,
} from "@/pages/AvMedMarketplaceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/avmed-marketplace-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "AvMed Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "AvMed Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "AvMed Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "AvMed Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/avmed-marketplace-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/avmed-marketplace-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AvMedMarketplaceInsurance />;
}
